import {  Form, Input } from 'antd';

export const FormInputItem = ({  name, rules, prefix, placeholder, type, className, pattern, onChange, disabled }) => {
  return (
    <Form.Item name={name} colon={false} rules={rules} >
      <Input pattern={pattern} className={className} style={{ padding: '10px' }} type={type} disabled={disabled} prefix={prefix} placeholder={placeholder} onChange={onChange ? onChange : () => {}} />
    </Form.Item>
  );
};
